import type { PubNubEventData } from 'v2/types/pubnub'
import { EventBus } from '.'
import { pubnubLogger } from '../logger'

export const pubnubEventBus = new EventBus<PubNubEventData>(pubnubLogger)
